import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

$(function(){
	const $photoWrapper = $('#photosWrapper');
	if(!$photoWrapper.length){
		return false;
	}

	const $photoCols = $('.photo-col');

	let imgIndex = 0;
	let pageNumber = 1;
	let canloadnext = true;
	let $shortest = null;

	let images = [];
	const items = [];
	let _colImages = {};
	$photoCols.each(function(i){
		_colImages[i] = [];
	});

	$photoWrapper.hitsBottom(function(threshold){
		fetchImages();
	}, 400);
	var obj = fetchImages();
	if(obj){
		obj.done(function(){
			fetchImages();
		});
	}


	function fetchImages(){
		if(canloadnext){
			canloadnext = false;
			return $.ajax({
				type: 'GET',
				url: setUrlParam({
					'by': $photoWrapper.data('selectedsort'),
					'seed': $photoWrapper.data('seed'),
					'page': pageNumber,
				}),
				success: function(data){
					if(placeImages(data)){
						pageNumber++;
						canloadnext = true;
						$(window).trigger('scroll');
					}
					else{
						canloadnext = false;
					}
				}

			});
		}
		return false;
	}

	function placeImages(data){
		if(data && data.length){
			for(var i=0; i<data.length; i++){
				for(var j=0; j<$photoCols.length; j++){
					var $col = $($photoCols[j]);
					if(!$shortest || parseInt($col.data('height')) < parseInt($shortest.data('height'))){
						$shortest = $col;
					}
				}

                const $img = $(data[i]);
                const colindex = $shortest.index();
                $img.data('index', imgIndex++);
				$img.data('col', colindex);
				_colImages[colindex].push($img);
				images.push($img);
				let pswpitem = {
					src: $img.data('path'),
                    width: $img.data('lwidth'),
					height: $img.data('lheight'),
                    type: 'image'
				};

				items.push(pswpitem);

                const height = parseInt($img.data('height'));
                $shortest.data('height', parseInt($shortest.data('height')) + height);
				if(isTiny){
					$($photoCols[0]).append($img);
				}
				else{
					$shortest.append($img);
				}

				var $realimg = $img.find('img:first');
				if($realimg[0]){
					$realimg[0].onload = function(){
						var $loader = $(this).next();
						$(this).parent().css({'margin-bottom':'0px'});
						if($loader.length){
							$loader.remove();
						}
					};
				}

			}

			return true;
		}
		else if(!images.length){
			$photoWrapper.find('.noresults:first').show();
		}
		return false;
	}

    const options = {
        zoom: false,
        zoomSVG: '<i class="fa fa-search-plus" aria-hidden="true"></i>',
        closeSVG: '<i class="fa fa-close" aria-hidden="true"></i>',
        counter: true,
        loop: false,
        bgOpacity: 0.92,
        padding: {top:0, bottom:0, left: 0, right: 0},
        pswpModule: () => import('photoswipe')
    };
    const pswp = new PhotoSwipeLightbox(options);

    const total = parseInt($photoWrapper.data('total'));
    pswp.addFilter('numItems', (numItems, dataSource) => {
        return total;
    });

    pswp.addFilter('itemData', (itemData, index) => {
        if(index === items.length-1 && canloadnext){
            console.log('fetching page ' + pageNumber);
            return new Promise((resolve, reject) => {
                fetchImages().done(function(){
                    pswp.pswp.refreshSlideContent(index);
                    pswp.pswp.ui.updatePreloaderVisibility();
                    return resolve(itemData);
                });
            });
        }
        return itemData;
    });

    pswp.on('change',() => {
        const index = pswp.pswp.currIndex;
        if(images[index]) {
            const $pswpInfoElement = $('#pswp__info');
            const $pswpAlbumElement = $('.pswp__button--album:first');
            const $info = images[index].find('.infowrapper:first').clone();
            $info.addClass('info-viewer');
            $info.css({display: 'block'});
            $pswpInfoElement.html($info);

            const $album = images[index].find('.albumname:first');
            $pswpAlbumElement.data('album', $album.data('album'));
            $pswpAlbumElement.html('<span><i class="fa fa-folder-o" aria-hidden="true"></i></span>&nbsp;&nbsp;' + $album.text().trim());
        }
    });

    pswp.on('uiRegister', function() {
        pswp.pswp.ui.registerElement({
            name: 'album',
            ariaLabel: 'Ablum',
            order: 5,
            isButton: true,
            html: '',
            onClick: (event, el) => {
                const al = $(el).data('album');
                if(al) {
                    document.location = setUrlParam({'album': al}, false, false);
                    return false;
                }
            }
        })
        pswp.pswp.ui.registerElement({
            name: 'info-wrapper',
            ariaLabel: 'Info',
            order: 100,
            isButton: false,
            appendTo: "wrapper",
            html: '<div id="pswp__info"></div>',
            onInit: (el, pswp) => {
                el.style.display = 'none';
            },
            onClick: (event, el) => {
                viewerInfo('hide');
            }
        });
        pswp.pswp.ui.registerElement({
            name: 'info',
            ariaLabel: 'Info',
            order: 8,
            isButton: true,
            html: '<i class="fa fa-info-circle" aria-hidden="true"></i>',
            onClick: (event, el) => {
                viewerInfo('toggle');
            }
        });
        pswp.pswp.ui.registerElement({
            name: 'download',
            ariaLabel: 'Download',
            order: 9,
            isButton: true,
            html: '<i class="fa fa-download" aria-hidden="true"></i>',
            onClick: (event, el) => {
                const index = pswp.pswp.currIndex;
                if(images[index]){
                    const ref = images[index].find('.toggle-download:first').attr('href');
                    if(ref){
                        document.location = ref;
                    }
                }
            }
        });
    });

    pswp.on('afterInit', () => {
        const index = pswp.pswp.currIndex;
        if(images[index]){
            viewerInfo(images[index].hasClass('infoup') ? 'show' : 'hide');
        }
    });

    pswp.init();


	function openViewer(index){
        pswp.loadAndOpen(index, items);
	}

	const breakpoint = 786 - 33;
	let isTiny = isBreakPoint(768);
	function moveImages(){
		if(isTiny){
			$($photoCols[0]).append(images);
		}
		else{
			$photoCols.each(function(i){
				$(this).append(_colImages[i]);
			});
		}
	}
	$(window).on('resize', function(e){
		if($(window).width() < breakpoint && !isTiny){
			isTiny = true;
			moveImages();
		}
		else if($(window).width() >= breakpoint && isTiny){
			isTiny = false;
			moveImages();
		}
	});
	moveImages();

	$.fn.infoup = function(){
		var $wrapper = $(this);
		var $info = $wrapper.find('.infowrapper:first');
		var $img = $wrapper.find('img:first');
		if($wrapper.hasClass('infoup')){
			$info.fadeOut(100);
			$img.removeClass('blurimg');
			$wrapper.removeClass('infoup');
		}
		else{
			$info.fadeIn(100);
			$img.addClass('blurimg');
			$wrapper.addClass('infoup');
		}
	}

	function viewerInfo(type){
        const $pswpInfoElement = $('.pswp__info-wrapper:first');
        const shown = $pswpInfoElement.is(':visible');
        const $button = $('.pswp__button--info:first');

		if(pswp){
			if(type === 'show'){
                $button.css({background: 'rgba(255, 255, 255, 0.7)'});
				$pswpInfoElement.fadeIn(0, 'swing');
			}
			else if(type === 'hide'){
				$pswpInfoElement.fadeOut(0, 'swing');
                $button.css({background: 'none'});
			}
			else{
				$pswpInfoElement.fadeToggle(0, 'swing');
                if(shown){
                    $button.css({background: 'none'});
                }
                else{
                    $button.css({background: 'rgba(255, 255, 255, 0.7)'});
                }
			}
		}
	}

	$photoWrapper.on('click', '.albumname', function(e){
		e.stopPropagation();
		var album = parseInt($(this).data('album'));
		document.location = setUrlParam({'album': album});
	});

	$photoWrapper.on('click', '.thumb, .toggle-zoom', function(e){
		e.stopPropagation();
		var $img = $(this).parents('.imgwrapper:first');
		openViewer($img.data('index'));
	});

	$photoWrapper.on('click', '.toggle-info', function(e){
		e.stopPropagation();
		var $wrapper = $(this).parents('.imgwrapper:first');
		$wrapper.infoup();

	});
	$photoWrapper.on('click', '.infowrapper', function(e){
		e.stopPropagation();
		var $wrapper = $(this).parents('.imgwrapper:first');
		$wrapper.infoup();
	});

	$('#droper').on('click', '.sort-select', function(e){
		e.stopPropagation();
		var by = parseInt($(this).data('sort'));
		document.location = setUrlParam({'by': by});
	});
});
